import { type AxiosPromise } from 'axios';

import { armorAPI } from '~/services/api';
import { type InsuranceSettingsJSON } from '~/types/Insurance';

const get: () => AxiosPromise<InsuranceSettingsJSON> = () =>
  armorAPI.request({
    method: 'GET',
    url: `/setting/insurance`,
  });

const put = (data: InsuranceSettingsJSON) =>
  armorAPI.request<InsuranceSettingsJSON>({
    data,
    method: 'PUT',
    url: `/setting/insurance`,
  });

export { get, put };
